module.exports = __webpack_public_path__ + "img/2.f15c2869.png";